var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddition01 = function SvgAddition01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 25h-15A2.5 2.5 0 0 1 0 22.5V2.501a2.5 2.5 0 0 1 2.5-2.5h8.75a.132.132 0 0 1 .034 0h.007a.188.188 0 0 0 .037.008c.11.007.219.028.323.063h.053a.526.526 0 0 1 .065.054c.136.06.26.145.366.25l7.5 7.5c.105.106.19.23.25.366.011.027.02.054.029.082v.035c.035.105.055.213.061.323a.123.123 0 0 0 .009.036v.008A.131.131 0 0 1 20 8.75V22.5A2.5 2.5 0 0 1 17.5 25ZM2.5 2.501v20h15V10h-6.25C10.56 10 10 9.44 10 8.75V2.5H2.5Zm10 1.767v3.233h3.232L12.5 4.268ZM11.25 20h-2.5v-2.5h-2.5V15h2.5v-2.5h2.5V15h2.5v2.5h-2.5V20Z",
    fill: "#333"
  })));
};
export default SvgAddition01;